module.exports = __webpack_public_path__ + "img/天力福袋2.73d342cc.jpg";